import '@shui/core/sh-stepper';

import { Component, input, booleanAttribute, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'sh-stepper-item',
    template: '<ng-content />',
    imports: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    host: {
        '[attr.active]': 'active() ? "" : null',
        '[attr.color]': 'color() ?? null',
        '[attr.condensed]': 'condensed() ? "" : null',
        '[attr.disabled]': 'disabled() ? "" : null',
        '[attr.info]': 'info() ?? null',
        '[attr.label]': 'label() ?? null',
        '[attr.number]': 'number() ?? null',
        '[attr.type]': 'type() ?? null',
        '[attr.vertical]': 'vertical() ? "" : null'
    }
})
export class ShStepperItemComponent {
    /**
     * Defines if the stepper item is active or not. If set to `true`, the disabled property will
     * automatically be set to false.
     */
    public readonly active = input(false, { transform: booleanAttribute });

    /** Adds the primary or neutral styles as per the value 'primary' or 'neutral'. */
    public readonly color = input<string | number | undefined>(undefined);

    /** Adds condensed styles if set to `true`. */
    public readonly condensed = input(false, { transform: booleanAttribute });

    /** If set, disabled styles will be applied */
    public readonly disabled = input(false, { transform: booleanAttribute });

    /** Defines the label shown below the number. */
    public readonly info = input<string | number | undefined>(undefined);

    /** Defines the label shown below the number. */
    public readonly label = input<string | number | undefined>(undefined);

    /** Defines number of the stepper item. */
    public readonly number = input<string | number | undefined>(undefined);

    /**
     * Defines the type of the stepper item and the badge shown in it. Possible values are
     * `success`, `warning` and `error`. If let undefined no badge will be shown.
     */
    public readonly type = input<string | number | undefined>(undefined);

    /** Defaults false. When set to true, the stepper layout transforms to vertical. */
    public readonly vertical = input(false, { transform: booleanAttribute });
}
